import { io } from 'socket.io-client';
import { getFetch } from "src/utils/functions/queryRoute"

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.NODE_ENV === 'production' ? undefined : window.origin
// const URL = process.env.NODE_ENV === 'production' ? undefined : window.origin

const socket = io(URL)
// const socket = io(URL, {
//   transports: ["websocket", "polling"]
// })

const mergeData = async(d) => {
  // console.log(d)
  if (d) {
    const getCache = await getFetch("checkCache", {})
    const _cache = d.filter((el, i) => getCache?.getAll?.[el?._id])
    const cache = _cache.map((el, i) => ({ ...el, active: true }))
    const merged = d.map(t1 => ({...t1, ...cache.find(t2 => t2._id === t1._id)}))
    return merged
  }else {
    return d
  }
}

export {
  socket,
  mergeData
}
